import api from "./api";
import RestEndpoints from "./constants/RestEndpoints";

export const getPreviouslyOrders = () => {
  return Promise.resolve(
    api.get<any>(`${RestEndpoints.PREVIOUSLY_ORDERS.ENDPOINT}`)
  );
};
